<template>
  <div
    class="progress-gauge"
    :style="{
      width: `${size}px`,
      height: `${size / 2}px`
    }"
  >
    <div class="steps">
      <span
        v-for="(step, index) in steps"
        :key="index"
        class="step"
      >{{ index }}</span>
    </div>

    <span class="gauge"></span>

    <small>{{ info }}</small>

    <span
      class="indicator"
      :style="{ transform: 'rotate('+ rotate +'deg)'}"
    ></span>

  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      default: () => 'new'
    },
    score: {
      type: Number,
      default: () => 0
    },
    scoreRequired: {
      type: Number,
      default: () => 0
    },
    question: {
      type: Number,
      default: () => 0
    },
    mandatoryq: {
      type: Number,
      default: () => 0
    },
    mandatoryqRequired: {
      type: Number,
      default: () => 0
    },
    size: {
      type: Number,
      default: () => 100
    }
  },

  data () {
    return {
      steps: 0,
      info: this.$t("progress-gauge.lvl-5"),
      rotate: -90
    }
  },

  created () {
    this.updateStatus()
  },

  updated () {
    this.updateStatus()
  },

  methods: {
    updateStatus () {
      let checkStatus = this.status
      if (this.status === 'new' &&
          this.score >= this.scoreRequired &&
          this.mandatoryq === this.mandatoryqRequired) {
        // in case your audit is ready to be sent
        checkStatus = 'ready'
      } else if (this.status == 'new' && this.score == 0 &&
                this.question == 0 && this.mandatoryq == 0) {
        // In case youv'e never answer the audit
        checkStatus = 'justcreate'
      }
      switch (checkStatus) {
        case 'justcreate':
          this.steps = 0
          this.info = this.$t("progress-gauge.lvl-1")
          this.rotate = -90
          break

        case 'new':
          this.steps = 1
          this.info = this.$t("progress-gauge.lvl-2")
          this.rotate = -30
          break

        case 'ready':
          this.steps = 2
          this.info = this.$t("progress-gauge.lvl-3")
          this.rotate = 30
          break

        case 'sent':
          this.steps = 3
          this.info = this.$t("progress-gauge.lvl-4")
          this.rotate = 90
          break

        case 'verify':
          this.steps = 3
          this.info = this.$t("progress-gauge.lvl-6")
          this.rotate = 90
          break

        case 'success':
          this.steps = 3
          this.info = this.$t("progress-gauge.lvl-7")
          this.rotate = 90
          break

        case 'failed':
          this.steps = 3
          this.info = this.$t("progress-gauge.lvl-8")
          this.rotate = 90
          break

        case 'oops':
          this.steps = 0
          this.info = this.$t("progress-gauge.lvl-5")
          this.rotate = -90
          break

        default:
          this.steps = 0
          this.info = this.$t("progress-gauge.lvl-5")
          this.rotate = -90
          break
      }
    }
  }
}
/* eslint-disable */
</script>

<style lang="scss" scoped>
@import '../../styles/components/progress/progress-gauge';

</style>
